import React, { useEffect, useRef, useState } from "react"
import { Header } from "../UI"
import DataTable from "react-data-table-component"
import JoditEditor from "jodit-react"
import { useDispatch, useSelector } from "react-redux"
import {
  AutoCompleteComponent,
  CheckBoxSelection,
  Inject,
  MultiSelectComponent,
} from "@syncfusion/ej2-react-dropdowns"
import { handleSendEmailApi, SendMsgEmail } from "../data/modal/SendMsgEmail"
import { openToastify } from "../store/actions/toastifyAction"
import { REDUX_TOASTIFY_DEFAULTS } from "../store/config"
import ImageUpload from "../data/modal/image/ImageUpload"
import { newsletter } from "../../axios/api/apiModule"

const Marketing = () => {
  let { customerListData } = useSelector((state) => state.customerReducer)
  const editor = useRef(null)
  const [smsContent, setSmsContent] = useState("")
  const [isSenderData, setIsSenderData] = useState([])
  const [isloading, setIsloading] = useState(false)
  const [isData, setIsData] = useState({
    sendMsg: false,
    sendEmail: false,
    subject: "",
    message: "",
  })
  const dispatch = useDispatch()
  const [isMsgEmail, setIsMsgEmail] = useState(true)
  const [uploadImages, setUploadImages] = useState([])
  const [newCustomerListData, setNewCustomerListData] = useState([])
  const [sendCounter, setCounter] = useState(0)
  const [enteredPhNo, setEnteredPhNo] = useState([])
  const [enteredEmail, setEnteredEmail] = useState([])
  const [listedPhNo, setListedPhNo] = useState([])
  const [skippedPhNo, setSkippedPhNo] = useState([])

  const handleNotification = (type, tittle, msg, to) => {
    const typeOfNotification = type //email or "sms"
    const subject = tittle
    const msgContent = msg
    const recipient = to
    // Call the SendMsgEmail function
    SendMsgEmail(typeOfNotification, subject, msgContent, recipient, dispatch)
  }

  const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms))

  const handleSend = async () => {
    setCounter(0)
    if (isData.subject === "" && isMsgEmail) {
      dispatch(
        openToastify(
          "Subject is Mendatory",
          REDUX_TOASTIFY_DEFAULTS.UPDATE_TOASTIFY_WARN()
        )
      )
      return
    }
    if (isData.message === "") {
      dispatch(
        openToastify(
          "Message is Mendatory",
          REDUX_TOASTIFY_DEFAULTS.UPDATE_TOASTIFY_WARN()
        )
      )
      return
    }

    if (isSenderData.length) {
      dispatch(
        openToastify(
          "Donot Leave or Refresh the page",
          REDUX_TOASTIFY_DEFAULTS.UPDATE_TOASTIFY_INFO()
        )
      )
      setIsloading(true)
      const header = `
      <table width="100%" cellpadding="0" cellspacing="0" border="0" style="
              background: #020202;
              color: white;
              padding: 1rem;
              border-radius: 10px;
              height: 5rem;
            ">
            <tbody><tr>
              <td align="center">
                <img src="https://boostmobiledetailing.ca/wp-content/uploads/2024/01/boost-detailing-logo.png" alt="logo" width="80">
              </td>
            </tr>        
            </tbody></table>
            <br>
            `
      const makeImgDownloadable = (htmlString) => {
        // Create a temporary DOM element to parse the HTML string
        const tempDiv = document.createElement("div")
        tempDiv.innerHTML = htmlString

        // Process all <img> tags
        const imgElements = tempDiv.querySelectorAll("img")
        imgElements.forEach((imgElement) => {
          const imgUrl = imgElement.src

          // Create an <a> wrapper with a download attribute if not already wrapped
          if (
            !imgElement.parentElement ||
            imgElement.parentElement.tagName !== "A"
          ) {
            const downloadLink = document.createElement("a")
            downloadLink.href = imgUrl
            // downloadLink.download = imgUrl.split("/").pop() // Use the filename for download
            downloadLink.setAttribute("download", "") // Add the `download` attribute // Use the filename for download

            // Wrap the <img> element inside the <a> tag
            imgElement.parentNode.insertBefore(downloadLink, imgElement)
            downloadLink.appendChild(imgElement)
          } else {
            // If already wrapped in an <a>, ensure the download attribute is present
            const parentLink = imgElement.parentElement
            if (!parentLink.hasAttribute("download")) {
              // parentLink.download = imgUrl.split("/").pop()
              parentLink.setAttribute("download", "") // Add the `download` attribute
            }
          }
        })

        // Return the updated HTML as a string
        return tempDiv.innerHTML
      }

      // isSenderData.forEach(async (customer, index) => {
      //   if (isMsgEmail) {
      //     const emails = isSenderData.map((customer) => {
      //       return customer?.email
      //     })

      //     console.log(
      //       makeImgDownloadable(isData.message),
      //       "makeImgDownloadable(isData.message)"
      //     )

      //     // handleSendEmailApi(
      //     //   emails,
      //     //   isData.subject,
      //     //   header + isData.message,
      //     //   uploadImages[0]
      //     // )

      //     handleNotification(
      //       "email",
      //       isData.subject,
      //       header + makeImgDownloadable(isData.message),
      //       customer?.email
      //     )
      //   } else {
      //     handleNotification(
      //       "sms",
      //       isData.subject,
      //       isData.message,
      //       customer?.phoneNumber
      //     )

      //     // ⏳ 5 second delay before next SMS
      //     await sleep(5000)
      //   }
      // })
      // if (isData.sendMsg) {
      //   handleNotification(
      //     "sms",
      //     isData.subject,
      //     smsContent,
      //     customer?.phoneNumber
      //   )
      // }
      // if (isData.sendEmail) {
      //   if (customer?.email) {
      //     handleNotification(
      //       "email",
      //       isData.subject,
      //       isData.message,
      //       customer?.email
      //     )
      //   }
      // } else {
      //   console.log("set isData.sendMsg || isData.sendEmail")
      //   dispatch(
      //     openToastify(
      //       "Select Message and Sms",
      //       REDUX_TOASTIFY_DEFAULTS.UPDATE_TOASTIFY_WARN()
      //     )
      //   )
      // }

      if (isMsgEmail) {
        // 1️⃣ Extract & clean emails
        const emails = isSenderData.map((val) => val?.email).filter(Boolean)

        const BATCH_SIZE = 100

        // 2️⃣ Create batches of 500
        for (let i = 0; i < emails.length; i += BATCH_SIZE) {
          const batch = emails.slice(i, i + BATCH_SIZE)

          console.log(`Sending batch ${i / BATCH_SIZE + 1}`, batch.length)

          // 3️⃣ Send email batch
          await handleSendEmailApi(
            batch,
            isData.subject,
            header + isData.message,
            dispatch
          )

          // 4️⃣ Wait 3 seconds before next batch
          if (i + BATCH_SIZE < emails.length) {
            await sleep(30000)
          }
        }

        console.log("All email batches sent")

        // handleNotification(
        //   "email",
        //   isData.subject,
        //   header + makeImgDownloadable(isData.message),
        //   emails
        // )
      } else {
        for (let index = 0; index < isSenderData.length; index++) {
          const customer = isSenderData[index]
          handleNotification(
            "sms",
            isData.subject,
            isData.message,
            customer?.phoneNumber
          )

          // ⏳ 5 second delay before next SMS
          await sleep(5000)
          setCounter((prev) => {
            return prev + 1
          })
        }
      }

      // setIsData((prevData) => ({
      //   ...prevData,
      //   subject: "",
      //   message: "",
      // }))
    } else {
      console.log("select receiver")
      dispatch(
        openToastify(
          "Sender Details are Mendatory",
          REDUX_TOASTIFY_DEFAULTS.UPDATE_TOASTIFY_WARN()
        )
      )
    }

    setTimeout(() => {
      setIsloading(false)
    }, 2000)
  }

  useEffect(() => {
    console.log(isSenderData)
  }, [isSenderData])

  // function removeHTMLTags(str) {
  //   return str.replace(/<\/?[^>]+(>|$)/g, "")
  // }
  useEffect(() => {
    setIsData((prevData) => ({
      ...prevData,
      message: "",
    }))
    console.log(isData, "isData")
    // if (isData.sendMsg) {
    //   const sms = removeHTMLTags(isData.message)
    //   setSmsContent(sms)
    // }
  }, [isMsgEmail])

  useEffect(() => {
    if (customerListData.length) {
      if (isMsgEmail) {
        const filteredCustomers = customerListData.filter(
          (customer) => !customer?.email?.toLowerCase().includes("info@boost")
        )

        setNewCustomerListData(filteredCustomers)
      } else {
        setNewCustomerListData(customerListData)
      }
    }
  }, [customerListData, isMsgEmail])

  // Function to find customers by phone numbers
  const findCustomersByPhoneNumbers = (phoneNumbers) => {
    return newCustomerListData?.filter((customer) =>
      phoneNumbers.includes(customer?.phoneNumber)
    )
  }
  const onChange = (args) => {
    console.log(args.target.value)
    const customers = findCustomersByPhoneNumbers(args.target.value)
    console.log("customers", customers)
    setIsSenderData(customers)
  }

  //Further can be used uploadImages State
  const handleImage = (images) => {
    console.log("images", images)
    setUploadImages(images)
  }

  // Custom template function to include both service name and price
  const customTemplate = (data) => (
    <div className="space-x-2">
      {/* <span>{data.index}</span> */}
      <span className="email">{data.email}</span>
      <span className="phoneNumber">{data.phoneNumber}</span>
    </div>
  )
  return (
    <>
      <div className="m-2 md:m-10 mt-24 p-2 md:p-10 bg-white rounded-3xl pb-5">
        <Header category="Page" title="Marketing" />
        {/* <DataTable
          // title="Coupons List"
          columns={mainColumns}
          data={Users}
          pagination
          fixedHeader
          selectableRows
          fixedHeaderScrollHeight="480px"
        /> */}
        <div className="pb-2 space-x-3">
          <button
            className={`${
              isMsgEmail
                ? "bg-yellow-light text-white"
                : "text-black border-black border-2"
            }  h-8 px-3 font-medium rounded-lg hover:shadow-md`}
            onClick={() => {
              setIsMsgEmail(true)
            }}
          >
            Send Email
          </button>
          <button
            className={`${
              isMsgEmail
                ? "text-black border-black border-2"
                : "bg-yellow-light text-white"
            } h-8 px-3 font-medium rounded-lg hover:shadow-md`}
            onClick={() => {
              setIsMsgEmail(false)
            }}
          >
            Send SMS
          </button>
        </div>

        <div className="flex items-end gap-4">
          <div className="overflow-hidden flex flex-col">
            <span>Select Receivers</span>
            <MultiSelectComponent
              placeholder="Select Recipient"
              dataSource={newCustomerListData ?? []}
              width={300}
              value={null}
              fields={{
                text: "phoneNumber",
                value: "phoneNumber",
              }}
              // allowFiltering={true}
              // enableVirtualization={true}
              mode="CheckBox"
              // mode="Default"
              showSelectAll={true}
              // showDropDownIcon={true}
              // enableSelectionOrder={true}
              popupHeight="350px"
              itemTemplate={customTemplate}
              onChange={onChange}
            >
              <Inject services={[CheckBoxSelection]} />
            </MultiSelectComponent>
          </div>
          <button
            className={`${
              newCustomerListData.length === isSenderData.length &&
              newCustomerListData.length !== 0
                ? "bg-yellow-light text-white"
                : "text-black border-black border-2"
            }  h-8 px-3 font-medium rounded-lg hover:shadow-md mb-1`}
            onClick={() => {
              if (
                newCustomerListData.length === isSenderData.length &&
                newCustomerListData.length !== 0
              ) {
                setIsSenderData([])
              } else {
                setIsSenderData(newCustomerListData)
              }
            }}
          >
            {newCustomerListData.length === isSenderData.length &&
            newCustomerListData.length !== 0
              ? `DeSelect All ${isSenderData.length}`
              : `Select All ${newCustomerListData.length}`}
          </button>

          <div className="flex flex-col lg:flex-row gap-1">
            <span>Selected:</span>
            <span>
              {isSenderData.length}/{newCustomerListData.length}
            </span>
          </div>
          <span>Prv Send: {sendCounter}</span>
        </div>

        {isMsgEmail ? (
          <div
            className={`mt-3 duration-200 delay-75 ${
              isMsgEmail ? "translate-x-0" : "translate-x-full"
            }`}
          >
            <div className="flex gap-5">
              <div className="flex flex-col">
                <span>Enter Emails {enteredPhNo.length}</span>
                <textarea
                  name=""
                  id=""
                  placeholder="email@email.com, example@example.com"
                  className="border border-gray-300"
                  rows={3}
                  cols={30}
                  onChange={(e) => {
                    const rawValue = e.target.value

                    const emailArray = rawValue
                      .split(/,|\n/) // split by comma or new line
                      .map((val) => {
                        return { email: val }
                      })

                    console.log(emailArray)
                    setEnteredEmail(emailArray)
                    setIsSenderData(emailArray)
                  }}
                ></textarea>
              </div>
            </div>
            <div>
              <span>Subject</span>
              <textarea
                className="border border-gray-300 w-full p-1"
                name="subject"
                id="subject"
                value={isData.subject}
                placeholder="Enter the subject"
                onChange={(e) => {
                  setIsData((prevData) => ({
                    ...prevData,
                    subject: e.target.value,
                  }))
                }}
              ></textarea>
            </div>
            <JoditEditor
              ref={editor}
              value={isData.message}
              onChange={(newContent) => {
                setIsData((prevData) => ({
                  ...prevData,
                  message: newContent,
                }))
              }}
            />
          </div>
        ) : (
          <div
            className={`mt-3 duration-200 delay-75 ${
              isMsgEmail ? "-translate-x-full" : "translate-x-0"
            }`}
          >
            <div className="flex gap-5">
              <div className="flex flex-col">
                <span>Enter Ph No. {enteredPhNo.length}</span>
                <textarea
                  name=""
                  id=""
                  placeholder="77788812345,77788812345"
                  className="border border-gray-300"
                  rows={3}
                  cols={30}
                  onChange={(e) => {
                    const rawValue = e.target.value

                    const phoneArray = rawValue
                      .split(/,|\n/) // split by comma or new line
                      .map((num) => num.trim())
                      .filter(Boolean)
                      .map((num) => {
                        const digits = num.replace(/\D/g, "") // remove non-digits
                        const formatted =
                          digits.length > 10 ? digits.slice(-10) : digits

                        return formatted.length === 10
                          ? { phoneNumber: formatted } // 👈 object instead of string
                          : null
                      })
                      .filter(Boolean) // remove null entries

                    setEnteredPhNo(phoneArray)
                    setListedPhNo(phoneArray)
                    setIsSenderData(phoneArray)
                  }}
                ></textarea>
              </div>
              <div className="flex flex-col">
                <span>Ready to Send {listedPhNo.length}</span>
                <textarea
                  name=""
                  id=""
                  className="border border-gray-300"
                  rows={3}
                  cols={30}
                  disabled
                  value={listedPhNo
                    .map((num) => {
                      return num.phoneNumber
                    })
                    .join(",")}
                ></textarea>
              </div>
              <div className="flex flex-col">
                <span>Skipped Ph No</span>
                <textarea
                  name=""
                  id=""
                  className="border border-gray-300"
                  rows={3}
                  cols={30}
                  disabled
                ></textarea>
              </div>
            </div>
            <div>
              <span>Enter SMS</span>
              <textarea
                className="border border-gray-300 w-full p-1 h-28"
                name="subject"
                id="subject"
                value={isData.message}
                placeholder="Enter SMS"
                onChange={(e) => {
                  setIsData((prevData) => ({
                    ...prevData,
                    message: e.target.value,
                  }))
                }}
              ></textarea>
            </div>
          </div>
        )}

        <div>
          <ImageUpload imageURLS={handleImage} />
        </div>

        <div className="mt-3 space-y-2">
          {/* <div className="flex space-x-3">
            <div className="space-x-2">
              <input
                className="mt-1"
                type="checkbox"
                name="sendEmail"
                id="sendEmail"
                checked={isData?.sendEmail}
                onChange={(e) => {
                  setIsData((item) => ({
                    ...item,
                    sendEmail: e.target.checked,
                  }))
                }}
              />
              <label htmlFor="sendEmail">Send Email?</label>
            </div>
            <div className="space-x-2">
              <input
                className="mt-1"
                type="checkbox"
                name="sendMsg"
                id="sendMsg"
                checked={isData?.sendMsg}
                onChange={(e) => {
                  setIsData((item) => ({
                    ...item,
                    sendMsg: e.target.checked,
                  }))
                }}
              />
              <label htmlFor="sendMsg">Send SMS?</label>
            </div>
          </div> */}
          <button
            className="flex bg-yellow-light py-1 px-4 items-center"
            onClick={() => {
              handleSend()
            }}
            disabled={isloading}
          >
            {isloading ? <span>SENDING...</span> : <span>SEND</span>}
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke-width="1.5"
              stroke="currentColor"
              className="size-4"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M6 12 3.269 3.125A59.769 59.769 0 0 1 21.485 12 59.768 59.768 0 0 1 3.27 20.875L5.999 12Zm0 0h7.5"
              />
            </svg>
          </button>
        </div>
      </div>
    </>
  )
}

export default Marketing
